import axios from "axios";
 
import jwt_decode from "jwt-decode"; 
import Swal from "sweetalert2";
import CryptoJS from 'crypto-js'; 
import Vue from 'vue'
export const state = {
 
};

export const getters = {
  isAuth(){     
    if(window.$cookies.get('ecampus')){   
      return true
    }else{  
      return false
    }
  },
  JWToken(){
    if(window.$cookies.get('ecampus')){   
      return CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      } 
  },
  UserRolles(){
      let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      return jwt_decode(token).roles
  },
};

export const mutations = {
  ClearJWToken() {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);  
  },
};


export const actions = {
 
  //GET
  async ActionsGet({dispatch}, Data) { 
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .get(
        Data["Service"] +
          "?PageNumber=" +
          Data["Page"].PageNumber +
          "&PageSize=" +
          Data["Page"].PageSize
      )
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //GET Single
  async ActionsSingleGet({dispatch}, Data) {
   if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .get(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //FİLTER GET 
 async ActionsFilterGet({dispatch}, Data) {  
  if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
  return axios
    .get(
      Data["Service"] +
        "?PageNumber=" +
        Data["Page"].PageNumber +
        "&PageSize=" +
        Data["Page"].PageSize +
        Data["Filter"]
    )
    .then((res) => res.data)
    .catch((error) => {  
      if(error.response.status == 401){    
        dispatch("logOut"); 
        return error.response.data 
      }else{
        return error.response.data 
      }
    });
}, 
  //FİLE GET 
  async ActionsFileGet({dispatch}, Data) {   
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios({
      url: Data["Service"]+Data["Filter"], // File URL Goes Here
      method: 'GET',
      responseType: 'blob',
  }) .then((res) => res.data)
  .catch((error) => {  
    if(error.response.status == 401){    
      dispatch("logOut"); 
      return error.response.data 
    }else{
      return error.response.data 
    }
  });

 
  }, 
  //POST
  async ActionsPost({dispatch}, Data) {
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .post(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  }, 
  
  //PUT
  async ActionsPut({dispatch}, Data) {
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .put(Data["Service"] + "/" + Data["Data"].Id, Data["Data"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //DELETE
  async ActionsDelete({dispatch}, Data) {
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .delete(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //SABİTLER
  async ActionsSabitGet({dispatch}, Tip) {
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    return axios
      .get("OKeyValues?Tip=" + Tip + "&PageNumber=1&PageSize=9999")
      .then((res) => {
        return res.data;
      });
  },

  //FastReport
  async FastReport({dispatch}, Data) {  
    if(window.$cookies.get('ecampus')) { dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })}
    axios({
      url: "GenericReport",
      method: "POST",
      responseType: "blob",
      data: Data,
    })
      .then((response) => {
    //YENİ SEKMEDE AÇMAK İÇİN
        let blob = new Blob([response.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob); 
        window.open(url);
      })
      .catch((error) => error.response.data);
    /* DİREK İNDİRMEK İÇİN 
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a'); 
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'file.pdf');
        document.body.appendChild(fileLink); 
        fileLink.click();
    */
  },
  
    //Login
    StrActionsLogin({commit},token) {  
      commit('SetJWToken', token);  
            return true  
      },  
      //Sayfa Yenilenince Token Tutmak İçin
      initAuth({commit}){
      let JWToken = window.$cookies.get('ecampus');    
      if(JWToken != undefined){
      commit("SetJWToken",JWToken) 
      }else{ 
      return false
      }

      },
      logOut({commit}){    
      commit("ClearJWToken")  
      window.location=this.$config.LOGIN_URL 
      },
      ActionsRefreshToken({commit,dispatch}){
      let Data={ Token: window.$cookies.get('ecampus') }
      console.log(Data);
      axios
      .post(this.$config.API_ACCOUNT_URL+"Account/refresh-token", Data)
      .then(res => {     
          if(res.data.Succeeded == true){      
            commit('SetJWToken', res.data.Data.Token); 
            dispatch("TokenZamaniHesaplama");
        } 
      })
      .catch((error) => error.response.data).catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;    
      },
      TokenZamaniHesaplama({dispatch}){
      // document.querySelector("html").setAttribute('dir', 'rtl')    
      var decoded = CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      decoded = jwt_decode(decoded); 
      decoded = new Date(decoded.exp * 1000) 
      // decoded = new Date('2022-02-03T14:53:30')
      let diffTime = Math.abs(new Date().valueOf() - decoded.valueOf());
      var kalanzaman = Math.floor(diffTime / (1000)); 
      kalanzaman = ((kalanzaman-30)*1000)  
      dispatch("CookiesZamanKontrol",kalanzaman); 

      }, 
      CookiesZamanKontrol({dispatch},kalanzaman){
      setTimeout(function () {

      let timerInterval;
      Swal.fire({
      title: "Oturum Süreniz Dolmak Üzere",
      html: "Son <b></b> saniye süreniz kaldı.",
      timer: 30000,
      timerProgressBar: true,
      confirmButtonText:"Devam",
      onBeforeOpen: () => {
      Swal.showLoading();
      timerInterval = setInterval(() => {
      Swal.getHtmlContainer().querySelector('b')
        .textContent = (Swal.getTimerLeft() / 1000)
          .toFixed(0)
      }, 100)
      },
      onClose: () => {
      clearInterval(timerInterval);
      }
      }).then(result => {
      console.log(result);
      if (
      /* Read more about handling dismissals below */
      result.dismiss === Swal.DismissReason.timer
      ) {
      dispatch("logOut");   
      }
      if(result.value){ 
      dispatch("ActionsRefreshToken");  
      }else{

      dispatch("logOut");   
      }
      }); 
      }.bind(this), kalanzaman);
      }, 

};
